import type { IErrorApiResponse, ISuccessApiResponse } from '@wyz/types';
import { OverridableQuery, useQuery, UseQueryOptions } from '@wyz/utils';
import { ConnectQueryKeys } from '~/connect/api';
import { useApi } from '~/common/context';

type CustomerGroup = {
  id: number;
  name: string;
};

type Options = {
  list?: OverridableQuery<
    UseQueryOptions<
      ISuccessApiResponse<Array<CustomerGroup>>,
      IErrorApiResponse
    >
  >;
};

export const useManageCustomerGroups = (options: Options = {}) => {
  const { callCoreApi } = useApi();

  return useQuery<ISuccessApiResponse<Array<CustomerGroup>>>({
    queryKey: ConnectQueryKeys.customerGroups.base(),
    queryFn: () =>
      callCoreApi<ISuccessApiResponse<Array<CustomerGroup>>>(
        '/settings/api/customer-groups',
        {},
      ),
    gcTime: Infinity,
    staleTime: Infinity,
    retry: false,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchInterval: false,
    enabled: Boolean(options?.list?.enabled),
  });
};
